import type {
  LanguageDTO,
  ListLanguagesResponseDTO,
} from "../../domain/dto/LanguageDTO";
import type { Language } from "../../domain/entities/Language";

export const mapLanguageDTO = (dto: LanguageDTO): Language => ({
  id: dto.id,
  code: dto.language_code ?? dto.code ?? "",
  name: dto.language ?? dto.name ?? dto.language_code ?? dto.code ?? "Unknown",
  subtitle: dto.subtitle ?? undefined,
});

export const mapLanguagesResponse = (
  response: ListLanguagesResponseDTO,
): Language[] => {
  const { data } = response;
  const languages = Array.isArray(data)
    ? data
    : typeof data === "object" && data
      ? (data.languages ?? [])
      : [];
  return languages.map(mapLanguageDTO);
};
